import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/about', label: 'À Propos' },
    { path: '/practical-info', label: 'Infos Pratiques' },
    { path: '/partners', label: 'Partenaires' },
    { path: '/join', label: 'Nous Rejoindre' },
    { href: 'https://neuviemecontinent.overblog.fr/', label: 'Blog', external: true }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-background/90 backdrop-blur-md border-b-2 border-[var(--y2k-primary)] shadow-[0_4px_0_var(--y2k-depth-1)]">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="relative w-14 h-14 transform transition-transform duration-700 group-hover:rotate-[360deg] group-hover:scale-110">
              <img 
                src="/logo-seul.svg" 
                alt="Neuvième Continent logo" 
                className="w-full h-full object-contain drop-shadow-md"
              />
            </div>
            <div className="hidden sm:block">
              <div className="font-pixel text-2xl font-bold text-[#ED4F9A] tracking-wide">
                Neuvième Continent
              </div>
              <div className="text-xs font-bold text-[var(--y2k-primary)] flex items-center gap-1 uppercase tracking-wider">
                Association de jeu de rôle
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-4 pt-2">
            {navLinks.map((link) => (
              link.external ? (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-y2k"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`btn-y2k ${isActive(link.path) ? 'active-nav' : ''}`}
                >
                  {link.label}
                </Link>
              )
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-xl border-2 border-[var(--y2k-primary)] bg-[var(--y2k-light)] text-[var(--y2k-primary)] hover:bg-[var(--y2k-depth-1)] transition-colors duration-200"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.2 }}
              className="lg:hidden overflow-hidden pb-6"
            >
              <div className="flex flex-col gap-4 pt-4 px-2">
                {navLinks.map((link) => (
                  link.external ? (
                    <a
                      key={link.label}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => setMobileMenuOpen(false)}
                      className="btn-y2k w-full text-center"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      key={link.path}
                      to={link.path}
                      onClick={() => setMobileMenuOpen(false)}
                      className={`btn-y2k w-full text-center ${isActive(link.path) ? 'active-nav' : ''}`}
                    >
                      {link.label}
                    </Link>
                  )
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
}

export default Header;